import { Box, Button, Menu, MenuItem, Typography, Modal } from "@mui/material";
import React, { useState } from "react";
import commonStyles from "../../../Utils/commonStyles";
import {
  DotsThree,
  GlobeHemisphereWest,
  Pencil,
  Plus,
  TextT,
  Trash,
  ListBullets,
  ListNumbers,
  Image,
} from "phosphor-react";
import fieldTemplatesStyles from "./FieldTemplatesStyles";
import { fdelete } from "../../../API/callsAPI";
import DeleteModal from "../../Utilities/DeleteModal/DeleteModal.component";

const SingleFieldView = ({
  title,
  showAddIcon,
  handleAddNew,
  fields,
  type,
  onFieldClick,
  selectedFields,
  handleGetTemplates,
}) => {
  const commonClasses = commonStyles();
  const classes = fieldTemplatesStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [isRemoveFieldModalOpen, setIsRemoveFieldModalOpen] = useState(false);
  const [selectedField, setSelectedField] = useState(null);

  const handleOpenMenu = (e) => {
    setAnchorEl(e.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleRemoveField = async () => {
    try {
      const res = await fdelete({
        url: `/trackables/trackable-field/${selectedField.id}/`,
      });
      setSelectedField(null);
      setIsRemoveFieldModalOpen(false);
      handleGetTemplates();
    } catch (error) {
      console.log(error);
    }
  };

  function getFieldIcon(type) {
    if (type === "string") {
      return <TextT size={20} style={{ color: "white" }} />;
    } else if (type === "media") {
      return <Image size={20} style={{ color: "white" }} />;
    } else if (type === "dropdown") {
      return <ListBullets size={20} style={{ color: "white" }} />;
    } else if (type === "integer") {
      return <ListNumbers size={20} style={{ color: "white" }} />;
    }
    return <TextT size={20} style={{ color: "white" }} />;
  }

  return (
    <Box>
      <Box className={commonClasses.flexAndGap8Px}>
        <Typography
          sx={{
            fontSize: "16px !important",
          }}
        >
          {title}
        </Typography>
        {showAddIcon && (
          <Button
            variant="outlined"
            sx={{
              width: "30px !important",
              height: "30px",
              padding: "0px !important",
              minWidth: "0px",
              border: "2px solid #6C65D9",
              color: "white",
            }}
            onClick={handleAddNew}
          >
            <Plus size={18} />
          </Button>
        )}
      </Box>
      {fields?.length ? (
        <Box
          className={commonClasses.flexAndGap8Px}
          sx={{ mt: 1, flexWrap: "wrap" }}
        >
          {fields.map((singleField) => {
            const isSelected = selectedFields.some(
              (sin) => sin?.name === singleField?.name
            );
            return (
              <Box
                key={singleField.id}
                className={commonClasses.flexAndGap8Px}
                sx={{
                  border: isSelected
                    ? "2px solid #6C65D9"
                    : "2px solid #606479",
                  backgroundColor: isSelected ? "#252A38" : "",
                  padding: "6px 10px",
                  borderRadius: "10px",
                  color: "white",
                  textTransform: "none",
                  cursor: "pointer",
                }}
                onClick={() => onFieldClick(singleField)}
              >
                {getFieldIcon(singleField.type)}
                <Typography>{singleField.name}</Typography>
                {type !== "default" ? (
                  <Button
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      handleOpenMenu(e);
                      setSelectedField(singleField);
                    }}
                    sx={{
                      minWidth: "10px",
                      padding: "1px",
                      color: "white",
                      ml: 1,
                    }}
                  >
                    <DotsThree size={25} weight="fill" color="white" />
                  </Button>
                ) : (
                  ""
                )}
              </Box>
            );
          })}
        </Box>
      ) : (
        "No Fields Found"
      )}
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        MenuListProps={{ className: `${classes.menuPop}` }}
      >
        <MenuItem
          className={classes.modalButton}
          onClick={() => {
            handleCloseMenu();
            setIsRemoveFieldModalOpen(true);
            // handleAddNew();
            // handleEditDepartmentInfo(depart);
          }}
          sx={{
            backgroundColor: "#252A38",
            color: "red",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            borderRadius: "0px",
          }}
        >
          <Trash className={classes.editIcon} />
          Remove Field
        </MenuItem>
      </Menu>
      <Modal
        open={isRemoveFieldModalOpen}
        onClose={() => setIsRemoveFieldModalOpen(false)}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <DeleteModal
          name={selectedField?.name}
          type="Field"
          handleCloseDeleteModal={() => setIsRemoveFieldModalOpen(false)}
          handleDelete={handleRemoveField}
        />
      </Modal>
    </Box>
  );
};

export default SingleFieldView;
